var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-list',{attrs:{"records":_vm.mutatedLogs,"fields":_vm.fields,"hide-record-count":true,"record-name":"Time Log"}})
}
var staticRenderFns = []

export { render, staticRenderFns }